import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ToastService} from "@shared/services/toast.service";

@Injectable({
  providedIn: 'root'
})
export class SettingsDattaService {

  constructor(private http: HttpClient, private toast: ToastService) {
  }

  public getSettingDetails() {
    return this.http.get('web/settings');
  }
  public updateSettingDetails(obj:any) {
    return this.http.put('web/settings', obj);
  }
}
